import { createSlice } from '@reduxjs/toolkit';
import { IWaterSystemsMetrics } from '../../../types';
import { fetchWaterSystemMetricsAsync,fetchWaterSystemMetricsAsyncBuilder } from './asyncRequests'


export interface WaterSystemsMetricsInitialState {
  data: IWaterSystemsMetrics;
  loading: boolean;
  error: string;
  success: boolean;
  pendingRequests: number;
}

const initialState: WaterSystemsMetricsInitialState = {
  data: [],
  loading: false,
  error: '',
  success: false,
  pendingRequests: 0,
}

export const WaterSystemsMetricsSlice = createSlice({
  name: 'waterSystemMetricsSlice',
  initialState,
  reducers: {
    resetWaterSystemMetricsData: (state) => {
      state.data = initialState.data
    }
  },
  extraReducers: (builder) => {
    fetchWaterSystemMetricsAsyncBuilder(builder);
  },
})

export const WaterSystemsMetricsActions = {
  ...WaterSystemsMetricsSlice.actions,
  fetchWaterSystemMetricsAsync,
}

export const WaterSystemsMetricsReducer = WaterSystemsMetricsSlice.reducer;
